// Helpers de avatar para Solicitante/Responsável dos chamados.
// Solicitante  -> foto do MS365 (Outlook) por e-mail.
// Responsável  -> foto subida no BenDesk; sem ela, MS365 do analista; senão iniciais.
import { API_BASE_URL } from "../services/api";

// API_ORIGIN = base sem o sufixo /api (avatar_url já vem como "/api/me/avatar/..").
export const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");

// Foto do MS365 por e-mail e/ou nome. O backend resolve o e-mail pelo nome
// (diretório) quando o chamado guardou só o nome do solicitante. 404 -> iniciais.
export const msPhotoUrl = (email, name) => {
  const p = new URLSearchParams();
  if (email) p.set("email", email);
  if (name) p.set("name", name);
  const qs = p.toString();
  return qs ? `${API_BASE_URL}/avatars/ms?${qs}` : null;
};

// src da foto de um analista (objeto vindo de /users/assignable):
// BenDesk upload -> MS365 -> null (iniciais).
export const analystAvatarSrc = (a) => {
  if (!a) return null;
  if (a.avatar_url) return `${API_ORIGIN}${a.avatar_url}`;
  return msPhotoUrl(a.email);
};

// Mapa "nome completo" -> analista (assigned_to guarda "first last").
export const buildAnalystByName = (analysts) => {
  const map = {};
  for (const a of analysts || []) {
    const full = `${a.first_name || ""} ${a.last_name || ""}`.trim().toLowerCase();
    if (full) map[full] = a;
  }
  return map;
};

// src do Responsável a partir do nome exibido no chamado + lista de analistas.
// Se o analista não estiver na lista, ainda tenta resolver a foto pelo nome.
export const assignedAvatarSrc = (assignedName, analystByName) => {
  const a = analystByName[(assignedName || "").trim().toLowerCase()];
  return a ? analystAvatarSrc(a) : msPhotoUrl(null, assignedName);
};
